import React from "react";
import { MdArrowBack } from "react-icons/md";

function CustomBackButton(props) {

    const goBack = () => {
        window.history.back();
    };
    return (<>
        <div style={{ margin: "2px 2px" }}>
            <button onClick={() => goBack()}
                className="back-screen-btn"
                style={{ borderRadius: 10 }}
            ><MdArrowBack /> Back</button>
        </div>
    </>)
}

export default CustomBackButton;